module.exports = __webpack_public_path__ + "img/user.6a08b79c.png";